import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MenusService {
  constructor() {}

  menus = [
    {
      id: 'home',
      nome: 'Home',
      icon: 'heroicons_outline:home',
      rota: 'home',
    },
    {
      id: 'solutions',
      nome: 'Soluções',
      icon: 'heroicons_outline:calculator',
      funcao: true,
    },
    {
      nome: 'Acesse Aqui',
      rota: 'dashboards',
      icon: 'heroicons_outline:desktop-computer',
    },




  ]

  menuLeitebem = [

    {
      nome: 'Leitebem',
      icon: 'dashboard',
      rota: '/servicos/leitebem',
    },
    {
      nome: 'Importar Animais',
      icon: 'iconsmind:cow',
      rota: '/servicos/leitebem/importar-animais'
    },
    {
      nome: 'Pesagens',
      icon: 'line_weight',
      rota: '/servicos/leitebem/pesagens'
    },
    {
      nome: 'Monitoramento',
      icon: 'iconsmind:monitoring',
      rota: '/servicos/leitebem/monitoramento'
    }
  ]
}
